export default "__VITE_ASSET__P$GBNLtF__"